{
    "ChartstyleoptionsPie2d": "Pie (2D)",
    "ChartstyleoptionsPie3d": "Pie (3D)",
    "ChartstyleoptionsDoughnut2d": "Doughnut (2D)",
    "ChartstyleoptionsDoughnut3d": "Doughnut (3D)",
    "ChartstyleoptionsLine": "Line",
    "ChartstyleoptionsArea": "Area",
    "ChartstyleoptionsAreastacked": "Area (Stacked)",
    "ChartstyleoptionsRadarpolararea": "Radar (Polar Area)",
    "ChartstyleoptionsColumn2d": "Column (2D)",
    "ChartstyleoptionsColumn2dstacked": "Column (2D, Stacked)",
    "ChartstyleoptionsColumn3d": "Column (3D)",
    "ChartstyleoptionsColumn3dstacked": "Column (3D, Stacked)",
    "ChartstyleoptionsBar2d": "Bar (2D)",
    "ChartstyleoptionsBar2dstacked": "Bar (2D, Stacked)",
    "ChartstyleoptionsBar3d": "Bar (3D)",
    "ChartstyleoptionsBar3dstacked": "Bar (3D, Stacked)",
    "NAME": "ChartStyleOptions"
}